<template>
  <div class="navbar-container d-flex content align-items-center">
    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link class="nav-link" @click="toggleVerticalMenuActive">
          <feather-icon icon="MenuIcon" size="21" />
        </b-link>
      </li>
    </ul>

    <b-navbar-nav class="nav align-items-right ml-auto">
      <li class="nav-item" v-if="isAdmin">
        <b-input-group>
          <b-input-group-prepend>
            <b-button variant="secondary">กอง</b-button>
          </b-input-group-prepend>
          <vue-select
            label="text"
            v-model="department"
            :options="departmentOptions"
            @input="onSelectedDepartmentChange"
            :clearable="false"
            class=""
            style="min-width: 250px;"
          />
        </b-input-group>

        <b-input-group>
          <b-input-group-prepend>
            <b-button variant="secondary">เจ้าหน้าที่</b-button>
          </b-input-group-prepend>
          <vue-select
            label="text"
            v-model="officer"
            :options="officerOptions"
            @input="onSelectedOfficerChange"
            :clearable="false"
            class=""
            style="min-width: 250px;"
          />
        </b-input-group>
      </li>
      <li class="nav-item" v-else>
        <b-input-group>
          <b-input-group-prepend>
            <b-button variant="secondary">กอง</b-button>
          </b-input-group-prepend>
          <vue-select
            label="text"
            v-model="userDepartment"
            :options="userDepartmentOptions"
            @input="onSelectedUserDepartmentChange"
            :clearable="false"
            class=""
            style="min-width: 250px;"
          />
        </b-input-group>
      </li>
    </b-navbar-nav>

    <!-- Left Col -->
    <div
      class="bookmark-wrapper align-items-center flex-grow-1 d-none d-lg-flex"
    >
      <!-- Bookmarks Container -->
      <!-- <bookmarks /> -->
    </div>

    <b-navbar-nav class="nav align-items-center ml-auto">
      <dark-Toggler class="d-none d-lg-block" />

      <!-- Notification -->
      <notification-dropdown 
        class="d-none d-lg-block"
        :objNotification="objNotification"
      />

      <li class="nav-item" v-if="isAdmin">
        <b-input-group>
          <b-input-group-prepend>
            <b-button variant="secondary">กลุ่มสิทธิ์</b-button>
          </b-input-group-prepend>
          <vue-select
            label="text"
            v-model="userRole"
            :options="adminUserRoleOptions"
            @input="onSelectedUserRoleChange"
            :clearable="false"
            class=""
            style="min-width: 250px;"
          />
        </b-input-group>
      </li>
      <li class="nav-item" v-else>
        <b-input-group>
          <b-input-group-prepend>
            <b-button variant="secondary">กลุ่มสิทธิ์</b-button>
          </b-input-group-prepend>
          <vue-select
            label="text"
            v-model="userRole"
            :options="userRoleOptions"
            @input="onSelectedUserRoleChange"
            :clearable="false"
            class=""
            style="min-width: 250px;"
          />
          <!-- <b-form-select
            v-model="userRole"
            :options="userRoleOptions"
            @change="onSelectedUserRoleChange"
            value-field="value"
            text-field="text"
            class=""
          /> -->
        </b-input-group>
      </li>

      <user-dropdown />
    </b-navbar-nav>
  </div>
</template>

<script>
import {
  BLink,
  BNavbarNav,
  BFormSelect,
  BInputGroup,
  BInputGroupPrepend,
  BButton,
} from "bootstrap-vue";
// import Bookmarks from './components/Bookmarks.vue'
// import SearchBar from './components/SearchBar.vue'
import DarkToggler from "./components/DarkToggler.vue";
// import CartDropdown from './components/CartDropdown.vue'
import NotificationDropdown from "./components/NotificationDropdown.vue";
import UserDropdown from "./components/UserDropdown.vue";
import VueSelect from "vue-select";
import * as userData from "@/auth/localStorageUtils.js";

import * as storeMaster from "@/store/api/master/index.js";
import * as departmentRoleStore from "@/store/api/role/departmentRole.js";

export default {
  components: {
    BLink,
    BFormSelect,
    BInputGroup,
    BInputGroupPrepend,
    BButton,
    // Navbar Components
    BNavbarNav,
    //  Bookmarks,
    //  SearchBar,
    DarkToggler,
    // CartDropdown,
    NotificationDropdown,
    UserDropdown,
    VueSelect,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("userData")),
      isAdmin: userData.isAdminRole(),
      departmentOptions: [],
      department: {
        value: userData.selectedAdminDepartment(),
        text: "",
      },
      officerOptions: [],
      officer: {
        value: userData.selectedAdminOfficer(),
        text: "",
      },
      userDepartmentOptions: userData.departmentRoles(),
      userDepartment: userData.selectedDepartmentRole(),
      userRoleOptions: userData.userRoles(),
      adminUserRoleOptions: [],
      userRole: userData.selectedUserRole(),
      userNotification: userData.userId(),
      objNotification : {
        userId: userData.userId(),
        complaintId: null,
        roleId: userData.selectedRole(),
        userType: 1,    
        provinceCode: userData.province(),
      },
    };
  },
  mounted() {
    if (userData.isAdminRole()) {
      this.getDepartmentDropdown();
      this.getOfficerDropdown();
      this.getUserRoleDropdown();
      // this.getCountNotification();
      console.log("userRole", this.userRole);
    }
  },
  methods: {
    onSelectedRoleChange() {
      console.log("onSelectedRoleChange", this.userData.selectedRole);

      localStorage.setItem("userData", JSON.stringify(this.userData));

      this.$router.go(this.$router.currentRoute);
    },
    onSelectedDepartmentChange() {
      console.log("onSelectedDepartmentChange", this.department);

      let currentUserData = this.userData;

      //console.log("is equal", this.department != null, this.department);

      if (this.department !== null) {
        currentUserData.selectedAdminDepartment = this.department.value;
      } else {
        currentUserData.selectedAdminDepartment = userData.departmentIdDefault();
      }

      localStorage.setItem("userData", JSON.stringify(this.userData));

      this.getOfficerDropdown(true);

      //this.$router.go(this.$router.currentRoute);
    },
    onSelectedOfficerChange() {
      console.log("onSelectedOfficerChange", this.officer);

      let currentUserData = this.userData;

      if (this.officer !== null) {
        currentUserData.selectedAdminOfficer = this.officer.value;
      } else {
        currentUserData.selectedAdminOfficer = userData.userIdDefault();
      }

      this.getUserRoleDropdown(true);

      // this.getCountNotification(this.officer);

      localStorage.setItem("userData", JSON.stringify(this.userData));

      //this.$router.go(this.$router.currentRoute);
    },
    onSelectedUserDepartmentChange() {
      const _this = this;
      console.log("onSelectedDepartmentChange", this.userDepartment);

      let currentUserData = this.userData;

      if (_this.userDepartment !== null) {
        const selectedData = userData.departmentRoles().find((value) => {
          return value.value === _this.userDepartment.value;
        });

        if (selectedData == null) {
          console.log("selectedData is null");
        }

        currentUserData.selectedUserDepartment = selectedData;

        // default roles ตัวแรกให้
        currentUserData.selectUserRole = selectedData.roles[0];
      } else {
        // currentUserData.selectedAdminDepartment = userData.departmentIdDefault();
      }

      localStorage.setItem("userData", JSON.stringify(currentUserData));

      this.$router.go(this.$router.currentRoute);
    },
    onSelectedUserRoleChange() {
      const _this = this;
      console.log("onSelectedUserRoleChange", _this.userRole);

      let currentUserData = this.userData;

      if (_this.userRole !== null) {
        let userRoles = userData.userRoles();
        if (userData.isAdminRole()) {
          userRoles = _this.adminUserRoleOptions;
        }
        const selectedData = userRoles.find((value) => {
          return value.value === _this.userRole.value;
        });

        if (selectedData == null) {
          console.log("selectedData is null");
        }

        currentUserData.selectUserRole = selectedData;
      } else {
        // currentUserData.selectedAdminDepartment = userData.departmentIdDefault();
      }

      localStorage.setItem("userData", JSON.stringify(currentUserData));

      this.$router.go(this.$router.currentRoute);
    },
    getDepartmentDropdown() {
      const _this = this;

      storeMaster
        .getDepartment(2)
        .then(function(response) {
          // handle success
          console.log("response", response);

          _this.departmentOptions = response.data.data;

          let selectedDepartmentOption = response.data.data.find((value) => {
            return value.value === _this.department.value;
          });
          console.log(
            "selectedDepartmentOptions",
            selectedDepartmentOption,
            _this.department.value
          );
          _this.department.text = selectedDepartmentOption.text;

          _this.$forceUpdate();
        })
        .catch(function(error) {
          // handle error
          console.log("error", error);
        });
    },
    getOfficerDropdown(refresh = false) {
      const _this = this;

      const params = {
        departmentId: _this.department.value,
      };

      departmentRoleStore
        .searchUser(params)
        .then(function(response) {
          // handle success
          console.log("response", response);

          var setDataList = [];

          response.data.data.forEach((o) => {
            var setData = {};
            setData.value = o.userId;
            setData.text = o.fName + " " + o.lName;

            setDataList.push(setData);
          });

          _this.officerOptions = setDataList;

          let selectedOfficerOption = _this.officerOptions.find((value) => {
            return value.value === _this.officer.value;
          });

          // เจอค่าแปลว่าเป็นการโหลดหน้าใหม่
          if (refresh != true) {
            _this.officer.text = selectedOfficerOption.text;
          } else {
            // ไม่เจอแปลว่ากดเปลี่ยนเอาจาก ui
            // set ค่าให้เป็นตัวแรก
            _this.officer = _this.officerOptions[0];
            _this.onSelectedOfficerChange();
          }

          _this.$forceUpdate();
        })
        .catch(function(error) {
          // handle error
          console.log("error", error);
        });
    },
    getUserRoleDropdown(refresh = false) {
      const _this = this;

      const params = {
        departmentId: _this.department.value,
        userId: _this.officer.value,
      };

      departmentRoleStore
        .getUserRoleByDepartmentId(params)
        .then(function(response) {
          // handle success
          console.log("response", response);

          _this.adminUserRoleOptions = response.data.data;

          let selectedRoleOption = _this.adminUserRoleOptions.find((value) => {
            return value.value === _this.userRole.value;
          });

          // โหลดหน้าใหม่เฉยๆไม่ต้องเซ็ทอะไร
          if (refresh != true) {
            _this.userRole.text = selectedRoleOption.text;
          } else {
            // กดเปลี่ยนเอาจาก ui
            // set ค่าให้เป็นตัวแรก
            _this.userRole = _this.adminUserRoleOptions[0];
            _this.onSelectedUserRoleChange();
          }

          _this.$forceUpdate();
        })
        .catch(function(error) {
          // handle error
          console.log("error", error);
        });
    },
  },
};
</script>
